import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import pxToRem from "../../Themes/Functions/pxToRem";

export default function WDErrorToast(props) {
  return (
    <Snackbar autoHideDuration={3000} {...props}>
      <Alert sx={{ minWidth: pxToRem(300) }} severity="error">
        {props.message || "Something Went Wrong"}
      </Alert>
    </Snackbar>
  );
}
